import $http from '$http'
import {
    util
} from 'utils';
import {
    lg
} from 'utils';

export default {
    methods: {
        //POST /api/NewAgent/NewCustomerAdd
        NewCustomerAdd(data) {
            this.loading = true;
            $http.post('api/NewAgent/NewCustomerAdd', data).then(res => {
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '已成功提交转正申请！',
                        type: 'success'
                    });

                    this.$emit('reload-list');
                    this.close();
                });
            });
        },
        // GET /api/NewAgent/GetById
        GetById() {
            var Params = {
                Sid: this.sysSid,
                Session: this.sysSession,
                Id: this.id
            };

            $http.get('api/NewAgent/GetById', Params).then(res => {
                let {
                    Data
                } = res.data;
                util.doResult(this, res, () => {
                    this.form = Data
                    this.baseInfo = this.form.Customer;
                    this.contact = this.form.Contact;
                    this.Companys = this.form.Companys

                });
            });
        },
        // 修改提交POST /api/NewAgent/NewCustomerModify
        AgentModify(data) {
            this.loading = true;

            $http.post('api/NewAgent/AgentModify', data).then(res => {
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功！',
                        type: 'success'
                    });

                    this.$emit('reload-list');
                    this.close();
                });
            });
        },


    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/CRMFormatAgent/components/edit-dialog/services.js